export const tr = {
    nav: {
        dashboard: 'Kontrol Paneli',
        board: 'Pano',
        list: 'Liste',
        settings: 'Ayarlar',
        reports: 'Raporlar',
        myTasks: 'Görevlerim',
        activity: 'Etkinlik',
        charts: 'Grafikler',
        team: 'Ekip',
        timeTracking: 'Zaman Takibi',
        admin: 'Yönetim',
        adminOverview: 'Yönetim Genel Bakış',
        userManagement: 'Kullanıcı Yönetimi',
        projectSetup: 'Proje Kurulumu',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Markdown Proje Yönetimi',
        version: 'Sürüm',
        back: 'Geri',
        loading: 'Yükleniyor...',
        noData: 'Veri yok',
        search: 'Ara',
        filter: 'Filtrele',
        all: 'Tümü',
        close: 'Kapat',
        open: 'Aç',
        connect: 'Bağlan',
        archived: 'Arşivlenmiş',
        inactive: 'Pasif',
        active: 'Aktif',
        untitled: 'Başlıksız',
        unknown: 'Bilinmeyen',
        tasks: 'Görevler',
        done: 'Tamamlandı',
        lastModified: 'Son değişiklik',
        created: 'Oluşturuldu',
        points: 'Puanlar',
        pts: 'puan',
        yes: 'Evet',
        no: 'Hayır',
        or: 'veya',
    },
    actions: {
        create: 'Oluştur',
        edit: 'Düzenle',
        delete: 'Sil',
        save: 'Kaydet',
        cancel: 'İptal',
        confirm: 'Onayla',
        add: 'Ekle',
        remove: 'Kaldır',
        update: 'Güncelle',
        close: 'Kapat',
        submit: 'Gönder',
        reset: 'Sıfırla',
        load: 'Yükle',
        export: 'Dışa Aktar',
        import: 'İçe Aktar',
        archive: 'Arşivle',
        restore: 'Geri Yükle',
        deactivate: 'Pasifleştir',
        activate: 'Aktifleştir',
    },
    auth: {
        signIn: 'Giriş Yap',
        signOut: 'Çıkış Yap',
        signUp: 'Kayıt Ol',
        username: 'Kullanıcı Adı',
        password: 'Şifre',
        confirmPassword: 'Şifreyi Onayla',
        displayName: 'Görünen Ad',
        email: 'E-posta',
        role: 'Rol',
        createAccount: 'Hesap Oluştur',
        dontHaveAccount: 'Hesabınız yok mu?',
        alreadyHaveAccount: 'Zaten bir hesabınız var mı?',
        signInToAccount: 'Hesabınıza giriş yapın',
        createYourAccount: 'Hesabınızı oluşturun',
        enterUsername: 'Kullanıcı adınızı girin',
        enterPassword: 'Şifrenizi girin',
        chooseUsername: 'Bir kullanıcı adı seçin',
        yourFullName: 'Adınız Soyadınız',
        atLeast6Chars: 'En az 6 karakter',
        confirmPasswordPlaceholder: 'Şifrenizi onaylayın',
        pleaseEnterCredentials: 'Lütfen kullanıcı adı ve şifre girin',
        invalidCredentials: 'Geçersiz kullanıcı adı veya şifre',
        pleaseFillAllFields: 'Lütfen tüm alanları doldurun',
        passwordsDoNotMatch: 'Şifreler eşleşmiyor',
        passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
        usernameExists: 'Kullanıcı adı zaten mevcut',
        demoCredentials: 'Demo giriş bilgileri',
        admin: 'Yönetici',
        manager: 'Proje Yöneticisi',
        developer: 'Geliştirici',
        viewer: 'Görüntüleyici',
        contactAdminForRole: 'Rol değişikliği için yönetici ile iletişime geçin',
        usernameCannotBeChanged: 'Kullanıcı adı değiştirilemez',
    },
    statuses: {
        backlog: 'Bekleme Listesi',
        todo: 'Yapılacak',
        inProgress: 'Devam Ediyor',
        inReview: 'İnceleniyor',
        done: 'Tamamlandı',
        planned: 'Planlandı',
        inProgressSprint: 'Devam Ediyor (Sprint)',
        completed: 'Tamamlandı',
        allStatus: 'Tüm Durumlar',
    },
    priorities: {
        critical: 'Kritik',
        high: 'Yüksek',
        medium: 'Orta',
        low: 'Düşük',
    },
    messages: {
        noProjects: 'Henüz proje yok',
        noTasks: 'Görev yok',
        confirmDelete: 'Bunu silmek istediğinizden emin misiniz?',
        saved: 'Başarıyla kaydedildi',
        error: 'Bir hata oluştu',
        noTasksAssigned: 'Size atanmış görev yok',
        noActivityYet: 'Henüz etkinlik yok',
        confirmReset: 'Bu işlem tüm verileri başlangıç durumuna sıfırlayacak. Devam edilsin mi?',
        removeUserConfirm: 'Bu kullanıcıyı kaldırmak istediğinizden emin misiniz?',
        deleteProjectConfirm: 'Bu projeyi silmek istediğinizden emin misiniz?',
        archiveProjectConfirm: 'Bu projeyi arşivlemek istediğinizden emin misiniz?',
    },
    settings: {
        title: 'Ayarlar',
        theme: 'Tema',
        language: 'Dil',
        languageAndRegion: 'Dil ve Bölge',
        gitConfig: 'Git Yapılandırması',
        gitIntegration: 'Git Entegrasyonu',
        gitProvider: 'Git Sağlayıcı',
        repositoryUrl: 'Depo URL',
        seedData: 'Örnek Veri',
        seedDataDescription: 'Test için görevler, sprintler ve epikler içeren örnek projeler yükleyin. Bu işlem tüm verileri başlangıç durumuna sıfırlayacaktır.',
        loadSeedData: 'Örnek Veri Yükle',
        seedDataConfirm: 'Bu işlem tüm verileri başlangıç durumuna sıfırlayacak. Devam edilsin mi?',
        appearance: 'Görünüm',
        notifications: 'Bildirimler',
    },
    themes: {
        summer: 'Yaz',
        spring: 'İlkbahar',
        autumn: 'Sonbahar',
        winter: 'Kış',
        day: 'Gündüz',
        night: 'Gece',
        summerDay: 'Yaz Gündüzü',
        summerNight: 'Yaz Gecesi',
        springDay: 'İlkbahar Gündüzü',
        springNight: 'İlkbahar Gecesi',
        autumnDay: 'Sonbahar Gündüzü',
        autumnNight: 'Sonbahar Gecesi',
        winterDay: 'Kış Gündüzü',
        winterNight: 'Kış Gecesi',
        highContrast: 'Yüksek Kontrast',
        selectTheme: 'Tema seçin',
    },
    time: {
        hours: 'saat',
        minutes: 'dakika',
        days: 'gün',
        weeks: 'hafta',
        justNow: 'az önce',
        minutesAgo: '{{count}} dk önce',
        hoursAgo: '{{count}} saat önce',
        daysAgo: '{{count}} gün önce',
        updatedAt: 'Güncellendi',
    },
    reports: {
        velocity: 'Hız',
        burndown: 'Yanma Grafiği',
        burnup: 'Yükselme Grafiği',
        cycleTime: 'Döngü Süresi',
        leadTime: 'Teslim Süresi',
        throughput: 'Verim',
        gantt: 'Gantt',
        cumulativeFlow: 'Kümülatif Akış',
    },
    globalSearch: {
        placeholder: 'Proje, görev, sprint ara...',
        noResults: 'Sonuç bulunamadı',
        projects: 'Projeler',
        tasks: 'Görevler',
        sprints: 'Sprintler',
        epics: 'Epikler',
    },
    notifications: {
        title: 'Bildirimler',
        markAllRead: 'Tümünü okundu olarak işaretle',
        clearAll: 'Tümünü temizle',
        empty: 'Bildirim yok',
        unread: '{count} okunmamış',
    },
    dashboard: {
        totalProjects: 'Toplam Proje',
        totalTasks: 'Toplam Görev',
        completion: 'Tamamlanma',
        statusBreakdown: 'Durum Dağılımı',
        createProject: 'Proje Oluştur',
        loadSeedData: 'Örnek Veri Yükle',
        noProjects: 'Henüz proje yok',
        getStarted: 'Yeni bir proje oluşturarak veya örnek veri yükleyerek başlayın.',
        projects: 'Projeler',
        newProject: 'Yeni Proje',
        createNewProject: 'Yeni Proje Oluştur',
        projectName: 'Proje Adı',
        description: 'Açıklama',
        workflow: 'İş Akışı',
        skipToMain: 'Ana içeriğe geç',
        projectProgress: 'Proje İlerlemesi',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Celali',
        hijri: 'Hicri',
        gregorian: 'Miladi',
    },
    accessibility: {
        skipToMain: 'Ana içeriğe geç',
        board: 'Görev panosu',
        projectList: 'Proje listesi',
        mainNav: 'Ana navigasyon',
        selectTheme: 'Tema seçin',
        projectDashboard: 'Proje kontrol paneli',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Pano',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Görev',
        createTask: 'Görev Oluştur',
        editTask: 'Görevi Düzenle',
        deleteTask: 'Görevi Sil',
        assignee: 'Sorumlu',
        unassigned: 'Atanmamış',
        storyPoints: 'Hikaye Puanı',
        labels: 'Etiketler',
        description: 'Açıklama',
        acceptanceCriteria: 'Kabul Kriterleri',
        timeLog: 'Zaman Kaydı',
        comments: 'Yorumlar',
        addComment: 'Yorum Ekle',
        noComments: 'Henüz yorum yok',
        status: 'Durum',
        priority: 'Öncelik',
        created: 'Oluşturuldu',
        updated: 'Güncellendi',
        started: 'Başlatıldı',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Sprint Oluştur',
        sprintGoal: 'Sprint Hedefi',
        committedPoints: 'Taahhüt Edilen Puan',
        completedPoints: 'Tamamlanan Puan',
        velocity: 'Hız',
        planned: 'Planlandı',
        inProgress: 'Devam Ediyor',
        completed: 'Tamamlandı',
    },
    team: {
        title: 'Ekip',
        members: 'Üyeler',
        role: 'Rol',
        availability: 'Müsaitlik',
        assignedTasks: 'Atanan Görevler',
        activeTasks: 'Aktif Görevler',
        doneTasks: 'Tamamlanan Görevler',
    },
    timeTracking: {
        title: 'Zaman Takibi',
        timer: 'Zamanlayıcı',
        manualEntry: 'Manuel Giriş',
        startTime: 'Başlangıç Zamanı',
        stopTime: 'Bitiş Zamanı',
        duration: 'Süre',
        date: 'Tarih',
        totalHours: 'Toplam Saat',
        entries: 'Kayıtlar',
        noEntries: 'Henüz kayıt yok',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Yönetim Paneli',
        projects: 'Projeler',
        totalTasks: 'Toplam Görev',
        storyPoints: 'Hikaye Puanı',
        taskStatusBreakdown: 'Görev Durumu Dağılımı',
        projectProgress: 'Proje İlerlemesi',
        teamWorkload: 'Ekip Yükü',
        assigned: 'Atanan',
        active: 'Aktif',
    },
    myTasks: {
        title: 'Görevlerim',
        total: 'Toplam',
        inProgress: 'Devam Ediyor',
        inReview: 'İnceleniyor',
        done: 'Tamamlandı',
        completion: 'Tamamlanma',
        allStatus: 'Tüm Durumlar',
        allProjects: 'Tüm Projeler',
        noTasksAssigned: 'Size atanmış görev yok',
    },
    activity: {
        title: 'Etkinlik Akışı',
        commentsOnYourTasks: 'Görevlerinizdeki Yorumlar',
        allActivity: 'Tüm Etkinlik',
        noActivityYet: 'Henüz etkinlik yok',
        commentedOn: 'yorum yaptı',
        movedTo: 'şuraya taşıdı',
    },
    profile: {
        title: 'Profil',
        avatar: 'Profil Fotoğrafı',
        dragDropImage: 'Bir resmi buraya sürükleyip bırakın veya dosya seçin',
        browse: 'Gözat',
        imageFormats: 'PNG, JPG, WEBP (maks. 2 MB)',
        removePhoto: 'Fotoğrafı Kaldır',
        saveChanges: 'Değişiklikleri Kaydet',
        profileSaved: 'Profil kaydedildi',
        contactAdmin: 'Rol değişikliği için yönetici ile iletişime geçin',
    },
};
//# sourceMappingURL=tr.js.map